import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider } from './contexts/AuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { CartProvider } from './contexts/CartContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Landing from './pages/Landing';
import Register from './pages/Register';
import AuthCallback from './pages/AuthCallback';
import Calendar from './pages/Calendar';
import Patients from './pages/Patients';
import PatientDetail from './pages/PatientDetail';
import Appointments from './pages/Appointments';
import Dashboard from './pages/Dashboard';
import Administration from './pages/Administration';
import Products from './pages/Products';
import Settings from './pages/Settings';
import Profile from './pages/Profile';
import RoleBasedRedirect from './components/RoleBasedRedirect';
import RoleProtectedRoute from './components/RoleProtectedRoute';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SettingsProvider>
        <AuthProvider>
          <CartProvider>
        <Router>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            
            {/* Protected routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <RoleProtectedRoute allowedRoles={['admin', 'dentist', 'assistant', 'receptionist']}>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </RoleProtectedRoute>
              </ProtectedRoute>
            } />
            
            <Route path="/calendar" element={
              <ProtectedRoute>
                <RoleProtectedRoute allowedRoles={['admin', 'dentist', 'assistant', 'receptionist']}>
                  <Layout>
                    <Calendar />
                  </Layout>
                </RoleProtectedRoute>
              </ProtectedRoute>
            } />
            
            <Route path="/patients" element={
              <ProtectedRoute>
                <RoleProtectedRoute allowedRoles={['admin', 'dentist', 'assistant', 'receptionist']}>
                  <Layout>
                    <Patients />
                  </Layout>
                </RoleProtectedRoute>
              </ProtectedRoute>
            } />
            
            <Route path="/patients/:id" element={
              <ProtectedRoute>
                <RoleProtectedRoute allowedRoles={['admin', 'dentist', 'assistant', 'receptionist']}>
                  <Layout>
                    <PatientDetail />
                  </Layout>
                </RoleProtectedRoute>
              </ProtectedRoute>
            } />
            
            <Route path="/appointments" element={
              <ProtectedRoute>
                <Layout>
                  <Appointments />
                </Layout>
              </ProtectedRoute>
            } />
            
            <Route path="/administration" element={
              <ProtectedRoute>
                <RoleProtectedRoute allowedRoles={['admin', 'dentist', 'assistant', 'receptionist']}>
                  <Layout>
                    <Administration />
                  </Layout>
                </RoleProtectedRoute>
              </ProtectedRoute>
            } />
            
            <Route path="/products" element={
              <ProtectedRoute>
                <RoleProtectedRoute allowedRoles={['admin', 'dentist', 'assistant', 'receptionist']}>
                  <Layout>
                    <Products />
                  </Layout>
                </RoleProtectedRoute>
              </ProtectedRoute>
            } />
            
            <Route path="/settings" element={
              <ProtectedRoute>
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <Layout>
                    <Settings />
                  </Layout>
                </RoleProtectedRoute>
              </ProtectedRoute>
            } />
            
            <Route path="/profile" element={
              <ProtectedRoute>
                <Layout>
                  <Profile />
                </Layout>
              </ProtectedRoute>
            } />
            
            {/* Redirect /app based on user role */}
            <Route path="/app" element={
              <ProtectedRoute>
                <RoleBasedRedirect />
              </ProtectedRoute>
            } />
          </Routes>
        </Router>
          </CartProvider>
      </AuthProvider>
      </SettingsProvider>
    </QueryClientProvider>
  );
}

export default App;















